/* eslint-disable react/require-default-props */
// Temporary Component to avoid SSR error for fusion accordion
import React from 'react';
import PropTypes from 'prop-types';
import { SpecificationsAccordionTitle } from '@thd-olt-component-react/specifications';

export const BundleSpecificationsAccordionTitle = ({ itemId, showSubtitle = false }) => {
  return (
    <SpecificationsAccordionTitle itemId={itemId} showSubtitle={showSubtitle} />
  );
};

BundleSpecificationsAccordionTitle.displayName = 'BundleSpecificationsAccordionTitle';
BundleSpecificationsAccordionTitle.propTypes = {
  itemId: PropTypes.string.isRequired,
  showSubtitle: PropTypes.bool
};
